module.exports = __webpack_public_path__ + "static/img/Jarrod_Witts_desktop.79563f6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Jarrod_Witts_desktop.jpg
// module id = WAhh
// module chunks = 0